import { ERROR_REMOVE_PI_NOT_FOUND } from '../constants/errors';
import { paramName } from '../constants/parameterNames';
import { failure, success } from '../helpers/commandResult';
import { getParamValue } from '../helpers/parameter.accessors';
import { removePi } from '../helpers/qRules.node.helpers';

const description = "Remove a processing instruction from the xml file.";

const requiredParameters = {
    [paramName]: {
        name: 'name',
        description: 'Name of the processing instruction to remove'
    },
};

function execute({ dataSources, parameters }) {
    const name = getParamValue(parameters, paramName);

    return removePi(dataSources, name, null)
        ? success()
        : failure(ERROR_REMOVE_PI_NOT_FOUND);
}

const RemovePi = {
    description,
    execute,
    requiredParameters,
};

export default RemovePi;